'use client';

import React, { createContext, useContext } from 'react';
import { createRepositories } from './factory';
interface HttpProviderProps {
  children: React.ReactNode;
  headers: {
    cookie: string;
    setCookie: string;
  };
}
const HttpContext = createContext<ReturnType<typeof createRepositories> | null>(null);
export function useHttp() {
  const http = useContext(HttpContext);
  if (!http) {
    throw new Error('useHttp must be used within a HttpProvider');
  }
  return http;
}
export function HttpProvider({
  children,
  headers
}: HttpProviderProps) {
  const repositories = createRepositories(headers);
  return <HttpContext.Provider value={repositories} data-sentry-element="unknown" data-sentry-component="HttpProvider" data-sentry-source-file="provider.tsx">{children}</HttpContext.Provider>;
}